// Angular dependencies
import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener
} from '@angular/core';

// Store
import { Store, State } from '@ngrx/store';
import {
  AppState,

  GotoMainAction,
  GotoBackAction,
} from '../../store.module';

@Component({
  selector: 'app-location-back',
  templateUrl: './location-back.component.html',
  styleUrls: ['./location-back.component.scss']
})
export class LocationBackComponent {
  @Output() confirm: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private _store: Store<AppState>
  ) {
  }

  onBack() {
    if (this.confirm.observers.length) {
      this.confirm.emit(() => {
        this.back();
      });
      return;
    }

    this.back();
  }

  back() {
    if (window.history.length === 2) {
      this._store.dispatch(new GotoMainAction());
      return;
    }

    this._store.dispatch(new GotoBackAction());
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/location-back.component/location-back.component.ts